import { useState, useEffect } from 'react'
import api from '../../api/axiosInstance'
import Swal from 'sweetalert2'
import { useSelector } from 'react-redux'
import { selectUser } from '../../redux/features/auth/authSelectors'
import { getUserPlan } from '../../utils/plan'
import ModernCronScheduleEditor from '../../components/cronShceduler/cronShceduleSelector'

import {
  Box,
  Typography,
  Grid,
  Button,
  TextField,
  useTheme,
  MenuItem,
  FormControl,
  Select,
  Divider,
  IconButton,
  FormHelperText,
  Slider,
  Alert,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
  InputAdornment,
  Chip,
  Card,
  CardContent,
  alpha,
} from '@mui/material'
import { motion } from 'framer-motion'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Timer as TimerIcon,
  Public as PublicIcon,
  Code as CodeIcon,
  DeveloperBoard as DeveloperBoardIcon,
  Add,
  Remove,
} from '@mui/icons-material'
import ComputerIcon from '@mui/icons-material/Computer'
import { useNavigate, useParams } from 'react-router-dom'
import { cookies } from '../../utils/cookie'
import { jwtDecode } from 'jwt-decode'
import { useFormik } from 'formik'
import {
  newHttpMonitorFormSchema,
  newPingMonitorFormSchema,
  newPortMonitorFormSchema,
  newKeywordMonitorFormSchema,
  newCronJobMonitorFormSchema,
} from '../../utils/formSchema/formSchemas'

const monitorAlertMessages = [
  {
    monitorType: 'http',
    message:
      'HTTPS Monitörü, belirlediğiniz bir web adresine (örneğin https://www.ornek.com) belirli aralıklarla istekte bulunarak sitenin erişilebilirliğini ve düzgün yanıt verip vermediğini kontrol eder. Sunucudan gelen HTTP durum kodunu (200, 404, 500 gibi) ve sayfanın yanıt süresini izler. Site yanıt veremediğinde, belirttiğiniz  kodlarla eğer eşleşmediğinde  sizi bilgilendirir. Bu monitör, web sitelerinin genel durumu ve performansı hakkında düzenli izleme sağlar.',
  },
  {
    monitorType: 'ping',
    message: `Ping Monitörü, bir sunucunun çevrimiçi (erişilebilir) olup olmadığını kontrol etmek için ICMP protokolünü kullanarak düzenli aralıklarla sinyal gönderir. Gönderilen bu 'ping' sinyallerine sunucu cevap verirse, sunucunun aktif olduğu anlaşılır. Eğer yanıt alınamazsa veya yanıt süresi çok uzarsa, bu durum bağlantı problemi veya kesinti olarak değerlendirilir. Ping monitörü, özellikle ağ bağlantısı takibi ve temel erişilebilirlik kontrolü için hızlı ve etkili bir çözümdür.`,
  },
  {
    monitorType: 'port',
    message: `Port Monitörü, belirli bir IP adresinde ya da alan adında tanımladığınız ağ portunun (örneğin 21, 22, 80, 443 gibi) açık ve ulaşılabilir olup olmadığını düzenli olarak kontrol eder. Belirtilen porta bağlantı sağlanamazsa, bu genellikle hizmetin kapalı, sunucunun yanıt vermediği ya da ağ bağlantısında bir sorun olduğu anlamına gelir. Port Monitörü sayesinde, örneğin bir FTP, SSH, HTTP veya özel bir uygulama servisinin çalışıp çalışmadığını anlık olarak takip edebilirsiniz.`,
  },
  {
    monitorType: 'keyword',
    message: `Anahtar Kelime Monitörü, belirli bir web sayfasının içeriğinde sizin belirlediğiniz kelimelerin var olup olmadığını düzenli aralıklarla kontrol eder. Belirttiğiniz kelime bulunmazsa ya da istenmeyen bir kelime tespit edilirse sizi uyarır. Bu sayede, bir hata mesajı, bakım bildirimi ya da içerik değişikliği gibi durumları hızlıca fark edebilirsiniz.`,
  },
  {
    monitorType: 'cronjob',
    message: `Cron Job Monitörü, zamanlanmış görevlerin (cron job'ların) düzgün şekilde çalışıp çalışmadığını takip eder. Genellikle sunucu tarafında arka planda belirli aralıklarla çalışan bu görevler,monitöre entegre edilen özel bir URL'ye her çalıştıklarında istek gönderir. Eğer belirlenen süre içinde bu istek gelmezse, yani görev çalışmazsa veya hata alırsa sizi bilgilendirir. Bu sayede otomatik yedekleme, e-posta gönderimi veya veri işleme gibi kritik zamanlanmış görevlerin sorunsuz çalıştığından emin olabilirsiniz.`,
  },
]

const ModernNewMonitorPage2 = (update = false) => {
  const userReducer = useSelector(selectUser)
  const plan = getUserPlan(userReducer)
  const [params, setParams] = useState(useParams())
  const [monitorType, setMonitorType] = useState('http')
  const [min, setMin] = useState(Number(plan?.limits.min_interval || 1))
  const [max, setMax] = useState(Number(plan?.limits.max_interval || 60))
  const [role, setRole] = useState('')
  const navigate = useNavigate()
  const theme = useTheme()
  const [vaidateOnChangeState, setValidateOnChangeState] = useState(false)
  const [vaidateOnBlurState, setValidateOnBlurState] = useState(true)

  const monitorTypes = [
    {
      id: 'http',
      icon: <PublicIcon sx={{ color: 'white' }} />,
      bgcolor: '#667eea',
      title: 'HTTP(S)',
      info: "Web sitelerini ve web API'lerini izleyin",
      access: plan?.features.http_monitoring,
    },
    {
      id: 'ping',
      icon: <ComputerIcon sx={{ color: 'white' }} />,
      bgcolor: '#f093fb',
      title: 'PING',
      info: 'Ağ bağlantısından ICMP protokolünden izleyin',
      access: plan?.features.ping_monitoring,
    },
    {
      id: 'port',
      icon: <DeveloperBoardIcon sx={{ color: 'white' }} />,
      bgcolor: '#4facfe',
      title: 'PORT',
      info: 'Belirli bağlantı portları izleyin',
      access: plan?.features.port_monitoring,
    },
    {
      id: 'keyword',
      icon: <CodeIcon sx={{ color: 'white' }} />,
      bgcolor: '#43e97b',
      title: 'KEYWORD',
      info: 'Web servislerdeki belirli anahtar kelimeleri izleyin',
      access: plan?.features.keyword_monitoring,
    },
    {
      id: 'cronjob',
      icon: <TimerIcon sx={{ color: 'white' }} />,
      bgcolor: '#fa709a',
      title: 'CRON JOB',
      info: 'Tekrarlanan işleri izleyin',
      access: plan?.features.cronjob_monitoring,
    },
  ]

  const HTTP_METHODS = [
    { value: 'GET', label: 'GET', access: plan?.features.get_request },
    { value: 'POST', label: 'POST', access: plan?.features.post_request },
    { value: 'PUT', label: 'PUT', access: plan?.features.put_request },
    { value: 'OPTIONS', label: 'OPTIONS', access: plan?.features.options_request },
    { value: 'DELETE', label: 'DELETE', access: plan?.features.delete_request },
    { value: 'PATCH', label: 'PATCH', access: plan?.features.patch_request },
    { value: 'HEAD', label: 'HEAD', access: plan?.features.head_request },
  ]

  const INTERVAL_UNITS = [
    { value: 'seconds', label: 'Saniye', access: plan?.features.second_interval },
    { value: 'minutes', label: 'Dakika', access: plan?.features.minute_interval },
    { value: 'hours', label: 'Saat', access: plan?.features.hour_interval },
  ]

   const getFormikConfig = () => {
    const baseConfig = {
      isInitialValid: false,
      validateOnChange: vaidateOnChangeState,
      validateOnBlur: vaidateOnBlurState,
      onSubmit: update.update ? updateMonitor : createMonitor,
    }

    switch (monitorType) {
      case 'http':
        return {
          ...baseConfig,
          initialValues: {
            name: '',
            host: '',
            method: 'HEAD',
            body: '',
            headers: '',
            allowedStatusCodes: '',
            timeOut: 30,
            cronSchedule: '*/5 * * * *',
            failCountRef: 3,
            slowResponseAlertStatus: false,
            slowResponseAlertValue: 1000,
            sslCertControl: false,
            sslCertExpire: false,
            domainExpire: false,
          },
          validationSchema: newHttpMonitorFormSchema,
        }
      case 'keyword':
        return {
          ...baseConfig,
          initialValues: {
            name: '',
            host: '',
            method: 'GET',
            body: '',
            headers: '',
            keyWord: '',
            keyWordType: 'txt',
            allowedStatusCodes: '',
            timeOut: 30,
            cronSchedule: '*/5 * * * *',
            failCountRef: 3,
            slowResponseAlertStatus: false,
            slowResponseAlertValue: 1000,
            sslCertControl: false,
            sslCertExpire: false,
            domainExpire: false,
          },
          validationSchema: newKeywordMonitorFormSchema,
        }
      case 'ping':
        return {
          ...baseConfig,
          initialValues: {
            name: '',
            host: '',
            cronSchedule: '*/5 * * * *',
            failCountRef: 3,
            slowResponseAlertStatus: false,
            slowResponseAlertValue: 1000,
          },
          validationSchema: newPingMonitorFormSchema,
        }
      case 'port':
        return {
          ...baseConfig,
          initialValues: {
            name: '',
            host: '',
            port: '',
            timeOut: 30,
            cronSchedule: '*/5 * * * *',
            failCountRef: 3,
            slowResponseAlertStatus: false,
            slowResponseAlertValue: 1000,
          },
          validationSchema: newPortMonitorFormSchema,
        }
      case 'cronjob':
        return {
          ...baseConfig,
          initialValues: {
            name: '',
            deviationTime: 0,
            failCountRef: 3,
          },
          validationSchema: newCronJobMonitorFormSchema,
        }
      // diğer case'ler...
      default:
        return {
          ...baseConfig,
          initialValues: {},
          validationSchema: null,
        }
    }
  }

  const handleIncrementForFailCount = () => {
    setFieldValue('failCountRef', values.failCountRef + 1)
  }

  const handleDecrementForFailCount = () => {
    setFieldValue('failCountRef', values.failCountRef - 1)
  }

  const alertContent = monitorAlertMessages.find(
    (item) => item.monitorType === monitorType,
  )?.message

  useEffect(() => {
    const fetchMonitorData = async () => {
      try {
        const jwtToken = cookies.get('jwt-access')
        if (jwtToken) {
          const decodedToken = jwtDecode(jwtToken)
          setRole(decodedToken.role)
        }
        const response = await api.get(`monitors/update/${params.id}`)
        
        switch (response.data.monitorType) {
          case 'HttpMonitor': {
            setMonitorType('http')
            setFieldValue('name', response.data.name)
            setFieldValue('host', response.data.httpMonitor.host)
            setFieldValue('method', response.data.httpMonitor.method)
            setFieldValue('headers', JSON.stringify(response.data.httpMonitor.headers))
            setFieldValue('body', JSON.stringify(response.data.httpMonitor.body))
            setFieldValue('allowedStatusCodes', response.data.httpMonitor.allowedStatusCodes ? response.data.httpMonitor.allowedStatusCodes.join(',') : '')
            setFieldValue('interval', response.data.interval)
            setFieldValue('intervalUnit', response.data.intervalUnit)
            setFieldValue('timeOut', response.data.httpMonitor.timeOut)
            setFieldValue('failCountRef', response.data.failCountRef)
            setFieldValue('slowResponseAlertStatus', response.data.httpMonitor.slowResponseAlertStatus)
            setFieldValue('slowResponseAlertValue', response.data.httpMonitor.slowResponseAlertValue)
            setFieldValue('sslCertControl', response.data.httpMonitor.sslCertControl)
            setFieldValue('sslCertExpire', response.data.httpMonitor.sslCertExpire)
            setFieldValue('domainExpire', response.data.httpMonitor.domainExpire)
            break
          }
          case 'PingMonitor': {
            setMonitorType('ping')
            setFieldValue('name', response.data.name)
            setFieldValue('host', response.data.pingMonitor.host)
            setFieldValue('interval', response.data.interval)
            setFieldValue('intervalUnit', response.data.intervalUnit)
            setFieldValue('failCountRef', response.data.failCountRef)
            setFieldValue('slowResponseAlertStatus', response.data.pingMonitor.slowResponseAlertStatus)
            setFieldValue('slowResponseAlertValue', response.data.pingMonitor.slowResponseAlertValue)
            break
          }
          case 'PortMonitor': {
            setMonitorType('port')
            setFieldValue('name', response.data.name)
            setFieldValue('host', response.data.portMonitor.host)
            setFieldValue('port', response.data.portMonitor.port)
            setFieldValue('timeOut', response.data.portMonitor.timeOut)
            setFieldValue('interval', response.data.interval)
            setFieldValue('intervalUnit', response.data.intervalUnit)
            setFieldValue('failCountRef', response.data.failCountRef)
            setFieldValue('slowResponseAlertStatus', response.data.portMonitor.slowResponseAlertStatus)
            setFieldValue('slowResponseAlertValue', response.data.portMonitor.slowResponseAlertValue)
            break
          }
          case 'KeywordMonitor': {
            setMonitorType('keyword')
            setFieldValue('name', response.data.name)
            setFieldValue('host', response.data.keyWordMonitor.host)
            setFieldValue('method', response.data.keyWordMonitor.method)
            setFieldValue('headers', response.data.keyWordMonitor.headers.length > 0 ? JSON.stringify(response.data.keyWordMonitor.headers) : '')
            setFieldValue('body', response.data.keyWordMonitor.body.length > 0 ? JSON.stringify(response.data.keyWordMonitor.body) : '')
            setFieldValue('keyWordType', response.data.keyWordMonitor.keyWordType || 'txt')
            setFieldValue('keyWord', response.data.keyWordMonitor.keyWord)
            setFieldValue('allowedStatusCodes', response.data.keyWordMonitor.allowedStatusCodes ? response.data.keyWordMonitor.allowedStatusCodes.join(',') : '')
            setFieldValue('interval', response.data.interval)
            setFieldValue('intervalUnit', response.data.intervalUnit)
            setFieldValue('timeOut', response.data.keyWordMonitor.timeOut)
            setFieldValue('failCountRef', response.data.failCountRef)
            setFieldValue('slowResponseAlertStatus', response.data.keyWordMonitor.slowResponseAlertStatus)
            setFieldValue('slowResponseAlertValue', response.data.keyWordMonitor.slowResponseAlertValue)
            setFieldValue('sslCertControl', response.data.keyWordMonitor.sslCertControl ?? false)
            setFieldValue('sslCertExpire', response.data.keyWordMonitor.sslCertExpire ?? false)
            setFieldValue('domainExpire', response.data.keyWordMonitor.domainExpire ?? false)
            break
          }
          case 'CronJobMonitor': {
            setMonitorType('cronjob')
            setFieldValue('name', response.data.name)
            setFieldValue('divitionTime', response.data.cronJobMonitor.devitionTime)
            setFieldValue('interval', response.data.interval)
            setFieldValue('intervalUnit', response.data.intervalUnit)
            setFieldValue('failCountRef', response.data.failCountRef)
            break
          }
          default:
            break
        }
      } catch (error) {
        Swal.fire({
          title: 'Hata',
          text: 'Monitor bilgileri alınırken bir hata oluştu.',
          icon: 'error',
          confirmButtonText: 'Tamam',
          background: theme.palette.background.paper,
          color: theme.palette.text.primary,
        })
        turnMonitorPage()
      }
    }

    if (update.update) {
      fetchMonitorData()
    } else {
      const jwtToken = cookies.get('jwt-access')
      if (jwtToken) {
        const decodedToken = jwtDecode(jwtToken)
        setRole(decodedToken.role)
      }
    }
  }, [])

  const getIntervalLimits = (unit) => {
    switch (unit) {
      case 'seconds':
        values.interval = values.interval <= 20 ? 20 : values.interval > 20 && values.interval <= 40 ? 40 : 60
        setMin(20)
        setMax(60)
        return { min: 20, max: 60 }
      case 'minutes':
        values.interval = values.interval > 0 && values.interval < 60 ? values.interval : 1
        setMin(Number(plan?.limits.min_interval || 1))
        setMax(Number(plan?.limits.max_interval || 60))
        return { min: Number(plan?.limits.min_interval || 1), max: Number(plan?.limits.max_interval || 60) }
      case 'hours':
        values.interval = values.interval > 0 && values.interval < 24 ? values.interval : 1
        setMin(1)
        setMax(24)
        return { min: 1, max: 24 }
      default:
        return
    }
  }

  const createMonitor = async (values) => {
    try {
      let url = ''
      let formattedData = {
        name: values.name,
        interval: values.interval,
        intervalUnit: values.intervalUnit,
        failCountRef: values.failCountRef,
      }

      switch (monitorType) {
        case 'http': {
          formattedData.httpMonitor = {
            host: values.host,
            method: values.method,
            body: values.body.length > 0 ? JSON.parse(values.body) : {},
            headers: values.headers.length > 0 ? JSON.parse(values.headers) : {},
            allowedStatusCodes: values.allowedStatusCodes.length > 0 ? values.allowedStatusCodes.split(',').map((code) => code?.trim()) : [],
            timeOut: values.timeOut,
            slowResponseAlertStatus: values.slowResponseAlertStatus,
            slowResponseAlertValue: values.slowResponseAlertValue,
            sslCertControl: values.sslCertControl,
            sslCertExpire: values.sslCertExpire,
            domainExpire: values.domainExpire,
          }
          url = role === 'admin' ? `monitors/http/${params.userId}` : `monitors/http/`
          break
        }
        case 'ping': {
          formattedData.pingMonitor = {
            host: values.host,
            slowResponseAlertStatus: values.slowResponseAlertStatus,
            slowResponseAlertValue: values.slowResponseAlertValue,
          }
          url = role === 'admin' ? `monitors/ping/${params.userId}` : `monitors/ping/`
          break
        }
        case 'port': {
          formattedData.portMonitor = {
            host: values.host,
            port: Number(values.port),
            timeOut: values.timeOut,
            slowResponseAlertStatus: values.slowResponseAlertStatus,
            slowResponseAlertValue: values.slowResponseAlertValue,
          }
          url = role === 'admin' ? `monitors/port/${params.userId}` : `monitors/port/`
          break
        }
        case 'keyword': {
          formattedData.keyWordMonitor = {
            host: values.host,
            method: values.method,
            body: values.body.length > 0 ? JSON.parse(values.body) : {},
            headers: values.headers.length > 0 ? JSON.parse(values.headers) : {},
            keyWordType: values.keyWordType,
            keyWord: values.keyWord,
            allowedStatusCodes: values.allowedStatusCodes.length > 0 ? values.allowedStatusCodes.split(',').map((code) => code.trim()) : [],
            timeOut: values.timeOut,
            slowResponseAlertStatus: values.slowResponseAlertStatus,
            slowResponseAlertValue: values.slowResponseAlertValue,
            sslCertControl: values.sslCertControl,
            sslCertExpire: values.sslCertExpire,
            domainExpire: values.domainExpire,
          }
          url = role === 'admin' ? `monitors/keyword/${params.userId}` : `monitors/keyword/`
          break
        }
        case 'cronjob': {
          formattedData = {
            name: values.name,
            cronJobMonitor: {
              devitionTime: Number(values.divitionTime),
            },
            interval: values.interval,
            intervalUnit: values.intervalUnit,
            failCountRef: values.failCountRef,
          }
          url = role === 'admin' ? `monitors/cronjob/${params.userId}` : `monitors/cronjob/`
          break
        }
        default:
          break
      }

      const response = await api.post(url, formattedData)
      if (response.data) {
        Swal.fire({
          title: 'İzleme Başarılı Şekilde Oluşturuldu',
          icon: 'success',
          confirmButtonText: 'Tamam',
          background: theme.palette.background.paper,
          color: theme.palette.text.primary,
          confirmButtonColor: theme.palette.primary.main,
        })
        turnMonitorPage()
      }
    } catch (error) {
      Swal.fire({
        title: error.response?.data?.message || 'Hata oluştu',
        icon: 'error',
        confirmButtonText: 'Tamam',
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        confirmButtonColor: theme.palette.primary.main,
      })
    }
  }

  const updateMonitor = async () => {
    try {
      let url = ''
      let formattedData = {
        name: values.name,
        interval: values.interval,
        intervalUnit: values.intervalUnit,
        failCountRef: values.failCountRef,
      }

      switch (monitorType) {
        case 'http': {
          formattedData.httpMonitor = {
            host: values.host,
            method: values.method,
            body: values.body.length > 0 ? JSON.parse(values.body) : {},
            headers: values.headers.length > 0 ? JSON.parse(values.headers) : {},
            allowedStatusCodes: values.allowedStatusCodes.length > 0 ? values.allowedStatusCodes.split(',').map((code) => code.trim()) : [],
            timeOut: values.timeOut,
            slowResponseAlertStatus: values.slowResponseAlertStatus,
            slowResponseAlertValue: values.slowResponseAlertValue,
            sslCertControl: values.sslCertControl,
            sslCertExpire: values.sslCertExpire,
            domainExpire: values.domainExpire,
          }
          url = `monitors/http/${params.id}`
          break
        }
        case 'ping': {
          formattedData.pingMonitor = {
            host: values.host,
            slowResponseAlertStatus: values.slowResponseAlertStatus,
            slowResponseAlertValue: values.slowResponseAlertValue,
          }
          url = `monitors/ping/${params.id}`
          break
        }
        case 'port': {
          formattedData.portMonitor = {
            host: values.host,
            port: Number(values.port),
            timeOut: values.timeOut,
            slowResponseAlertStatus: values.slowResponseAlertStatus,
            slowResponseAlertValue: values.slowResponseAlertValue,
          }
          url = `monitors/port/${params.id}`
          break
        }
        case 'keyword': {
          formattedData.keyWordMonitor = {
            host: values.host,
            method: values.method,
            body: values.body.length > 0 ? JSON.parse(values.body) : {},
            headers: values.headers.length > 0 ? JSON.parse(values.headers) : {},
            keyWordType: values.keyWordType,
            keyWord: values.keyWord,
            allowedStatusCodes: values.allowedStatusCodes.length > 0 ? values.allowedStatusCodes.split(',').map((code) => code.trim()) : [],
            timeOut: values.timeOut,
            slowResponseAlertStatus: values.slowResponseAlertStatus,
            slowResponseAlertValue: values.slowResponseAlertValue,
            sslCertControl: values.sslCertControl,
            sslCertExpire: values.sslCertExpire,
            domainExpire: values.domainExpire,
          }
          url = `monitors/keyword/${params.id}`
          break
        }
        case 'cronjob': {
          formattedData = {
            name: values.name,
            cronJobMonitor: {
              devitionTime: Number(values.divitionTime),
            },
            interval: values.interval,
            intervalUnit: values.intervalUnit,
            failCountRef: values.failCountRef,
          }
          url = `monitors/cronjob/${params.id}`
          break
        }
        default:
          break
      }

      const response = await api.put(url, formattedData)
      if (response.data) {
        Swal.fire({
          title: 'İzleme Başarılı Şekilde Güncellendi',
          icon: 'success',
          confirmButtonText: 'Tamam',
          background: theme.palette.background.paper,
          color: theme.palette.text.primary,
          confirmButtonColor: theme.palette.primary.main,
        })
        turnMonitorPage()
      }
    } catch (error) {
      Swal.fire({
        title: error.response?.data?.message || 'Hata oluştu',
        icon: 'error',
        confirmButtonText: 'Tamam',
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        confirmButtonColor: theme.palette.primary.main,
      })
    }
  }

  const handleMonitorTypeChange = (event) => {
    const newType = event.target.value
    setMonitorType(newType)
    if (newType === 'http') {
      setFieldValue('method', 'HEAD')
    } else if (newType === 'keyword') {
      setFieldValue('method', 'GET')
    }
  }

  const turnMonitorPage = () => {
    role === 'user' ? navigate('/user/monitors/') : navigate(`/admin/userMonitors/${params.userId}`)
  }

  const { values, errors, isValid, handleChange, handleSubmit, setFieldValue } = useFormik(getFormikConfig())

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setValidateOnChangeState(true)
      setValidateOnBlurState(false)
    }
  }, [errors])

  useEffect(() => {
    getIntervalLimits(values.intervalUnit)
  }, [values.intervalUnit])

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      sx={{ width: '100%' }}
    >
      {/* Modern Header */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 900,
            background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 1,
            fontSize: { xs: '1.5rem', md: '2rem' },
          }}
        >
          {update.update ? 'Monitor Güncelle' : 'Yeni Monitor Ekle'}
        </Typography>
        <Typography variant="body2" sx={{ color: alpha('#fff', 0.6) }}>
          Sistemlerinizi sürekli izleyin ve sorunları anında tespit edin
        </Typography>
      </Box>

      <Divider sx={{ mb: 4, borderColor: alpha(theme.palette.primary.main, 0.2) }} />

      {/* Alert Message */}
      {alertContent && (
        <Alert
          severity="info"
          sx={{
            mb: 3,
            background: alpha(theme.palette.info.main, 0.1),
            border: `1px solid ${alpha(theme.palette.info.main, 0.3)}`,
            borderRadius: 2,
          }}
        >
          {alertContent}
        </Alert>
      )}

      {/* Monitor Type Selection - MODERN CARDS */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
          Monitoring Tipi
        </Typography>
        
        <FormControl sx={{ display: 'flex' }}>
                  <Select
                    fullWidth
                    value={monitorType}
                    onChange={handleMonitorTypeChange}
                    displayEmpty
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          // bgcolor: theme.applyStyles.apply.,
                          borderRadius: 0
                        },
                      },
                    }}
                    sx={{
                      '& .MuiSelect-select': {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0,
                        py: 0.6,
                        
                      },
                    }}
                  >
                    {monitorTypes.map((item) => (
                      <MenuItem
                        key={item.id}
                        value={item.id}
                        sx={{
                          opacity: !item.access ? 0.6 : 1,
                          cursor: !item.access ? 'not-allowed' : 'pointer',
                        }}
                        onClick={() => {
                          if (!item.access) return
                          // normal akış
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            width: '100%',
                          }}
                        >
                          <Box
                            sx={{
                              bgcolor: item.bgcolor,
                              p: 0.6,
                              borderRadius: 1,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              minWidth: 48,
                            }}
                          >
                            {item.icon}
                          </Box>
        
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="subtitle2" fontWeight={500}>
                              {item.title}
                            </Typography>
        
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{
                                display: 'block',
                                width: { xs: '100%', sm: 'auto' },
                                mt: { xs: 0.5, sm: 0 },
                              }}
                            >
                              {item.info}
                            </Typography>
                          </Box>
        
                          {/* 🔒 Ücretli etiketi */}
                          {!item.access && (
                            <Chip
                              label="🔒 Paket Yükseltilmesi Gerekiyor"
                              size="small"
                              sx={{
                                height: 30,
                                fontSize: 15,
                                bgcolor: '#f5f5ff',
                                color: '#413ef8f3',
                                fontWeight: 500,
                              }}
                            />
                          )}
                        </Box>
                      </MenuItem>
                    ))}
        
                    <Divider />
                  </Select>
                  <FormHelperText
                    sx={{
                      justifyContent: 'start',
                      alignItems: 'center',
                      //bgcolor: '#99a7fa',
                    }}
                  ></FormHelperText>
                </FormControl>
      </Box>

      {/* BASIC INFORMATION CARD */}
      <Card
        sx={{
          mb: 3,
          background: alpha(theme.palette.background.paper, 0.8),
          backdropFilter: 'blur(20px)',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>
            Temel Bilgiler
          </Typography>

          <Grid container spacing={3}>
            {/* NAME */}
            <Grid item xs={12} md={6}>
              <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                Ad
              </Typography>
              <TextField
                id="name"
                required
                fullWidth
                placeholder="Tanımlayıcı ad"
                value={values.name}
                onChange={handleChange}
                error={!!errors.name}
                helperText={errors.name || ' '}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    background: alpha(theme.palette.background.default, 0.5),
                    borderRadius: 2,
                  },
                }}
              />
            </Grid>

            {/* HOST / DIVITION TIME */}
            {monitorType === 'cronjob' ? (
              <Grid item xs={12} md={6}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  Sapma Zamanı
                </Typography>
                <TextField
                  id="divitionTime"
                  required
                  fullWidth
                  placeholder="Sapma zamanı dakika cinsinden"
                  value={values.divitionTime}
                  onChange={handleChange}
                  error={!!errors.divitionTime}
                  helperText={errors.divitionTime || ' '}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>
            ) : (
              <Grid item xs={12} md={6}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  Host
                </Typography>
                <TextField
                  id="host"
                  required
                  fullWidth
                  placeholder="https://rahatup.com"
                  value={values.host}
                  onChange={handleChange}
                  error={!!errors.host}
                  helperText={errors.host || ' '}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>

      {/* INTERVAL */}
      <Card
        sx={{
          mb: 3,
          background: alpha(theme.palette.background.paper, 0.8),
          backdropFilter: 'blur(20px)',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 3 }}>
        

          <Grid container spacing={3}>
          
            <ModernCronScheduleEditor
                        value={values.cronSchedule}
                        setFieldValue={setFieldValue}
                      />
           

            {/* FAIL COUNT (for PING, PORT, CRONJOB) */}
            {/* {(monitorType === 'ping' || monitorType === 'port' || monitorType === 'cronjob') && (
              <Grid item xs={12} md={6}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  Kaç Hata Sonrası Bildirim Gönderilsin
                </Typography>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton
                    onClick={handleDecrementForFailCount}
                    disabled={values.failCountRef <= 1}
                    sx={{
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                      borderRadius: '8px 0 0 8px',
                      background: alpha(theme.palette.background.default, 0.5),
                      '&:hover': {
                        background: alpha(theme.palette.primary.main, 0.1),
                      },
                    }}
                  >
                    <Remove />
                  </IconButton>

                  <TextField
                    id="failCountRef"
                    name="failCountRef"
                    value={values.failCountRef}
                    fullWidth
                    onChange={handleChange}
                    type="number"
                    inputProps={{
                      style: { textAlign: 'center' },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        background: alpha(theme.palette.background.default, 0.5),
                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                          WebkitAppearance: 'none',
                          margin: 0,
                        },
                      },
                    }}
                  />

                  <IconButton
                    onClick={handleIncrementForFailCount}
                    sx={{
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                      borderRadius: '0 8px 8px 0',
                      background: alpha(theme.palette.background.default, 0.5),
                      '&:hover': {
                        background: alpha(theme.palette.primary.main, 0.1),
                      },
                    }}
                  >
                    <Add />
                  </IconButton>
                </Stack>
                <FormHelperText error={!!errors.failCountRef}>
                  {errors.failCountRef || ' '}
                </FormHelperText>
              </Grid>
            )} */}
          </Grid>
        </CardContent> 
      </Card>

      {/*METHOD CARD */}
      <Card
        sx={{
          mb: 3,
          background: alpha(theme.palette.background.paper, 0.8),
          backdropFilter: 'blur(20px)',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 3 }}>
        

          <Grid container spacing={3}>
            {/* METHOD (for HTTP & KEYWORD) */}
            {(monitorType === 'http' || monitorType === 'keyword') && (
              <Grid item xs={12}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  Method
                </Typography>
                <TextField
                  id="method"
                  name="method"
                  fullWidth
                  select
                  value={values.method}
                  onChange={(e) => setFieldValue('method', e.target.value)}
                  error={!!errors.method}
                  helperText={errors.method || ' '}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                    },
                  }}
                >
                  {HTTP_METHODS.filter(
                    (method) => !(monitorType === 'keyword' && method.value === 'HEAD')
                  ).map((method) => (
                    <MenuItem
                      key={method.value}
                      value={method.value}
                      disabled={!method.access}
                      sx={{ opacity: method.access ? 1 : 0.6 }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        {method.label}
                        {!method.access && (monitorType === 'http' || (monitorType === 'keyword' && method.value !== 'GET')) && (
                          <Chip
                            label="🔒 Ücretli"
                            size="small"
                            sx={{
                              height: 20,
                              fontSize: '0.65rem',
                              bgcolor: alpha(theme.palette.warning.main, 0.2),
                              color: theme.palette.warning.main,
                              ml: 1,
                            }}
                          />
                        )}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}

            {/* FAIL COUNT (for PING, PORT, CRONJOB) */}
            {(monitorType === 'ping' || monitorType === 'port' || monitorType === 'cronjob') && (
              <Grid item xs={12} md={6}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  Kaç Hata Sonrası Bildirim Gönderilsin
                </Typography>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton
                    onClick={handleDecrementForFailCount}
                    disabled={values.failCountRef <= 1}
                    sx={{
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                      borderRadius: '8px 0 0 8px',
                      background: alpha(theme.palette.background.default, 0.5),
                      '&:hover': {
                        background: alpha(theme.palette.primary.main, 0.1),
                      },
                    }}
                  >
                    <Remove />
                  </IconButton>

                  <TextField
                    id="failCountRef"
                    name="failCountRef"
                    value={values.failCountRef}
                    fullWidth
                    onChange={handleChange}
                    type="number"
                    inputProps={{
                      style: { textAlign: 'center' },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        background: alpha(theme.palette.background.default, 0.5),
                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                          WebkitAppearance: 'none',
                          margin: 0,
                        },
                      },
                    }}
                  />

                  <IconButton
                    onClick={handleIncrementForFailCount}
                    sx={{
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                      borderRadius: '0 8px 8px 0',
                      background: alpha(theme.palette.background.default, 0.5),
                      '&:hover': {
                        background: alpha(theme.palette.primary.main, 0.1),
                      },
                    }}
                  >
                    <Add />
                  </IconButton>
                </Stack>
                <FormHelperText error={!!errors.failCountRef}>
                  {errors.failCountRef || ' '}
                </FormHelperText>
              </Grid>
            )}
          </Grid>
        </CardContent> 
      </Card>

      {/* ADVANCED REQUEST DETAILS (for HTTP & KEYWORD) */}
      {(monitorType === 'http' || monitorType === 'keyword') && (
        <Accordion
          sx={{
            mb: 3,
            background: alpha(theme.palette.background.paper, 0.8),
            backdropFilter: 'blur(20px)',
            border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            borderRadius: '12px !important',
            '&:before': { display: 'none' },
            overflow: 'hidden',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              '& .MuiAccordionSummary-content': {
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              },
            }}
          >
            <Typography sx={{ fontWeight: 700 }}>
              Gönderilecek istek detayı
            </Typography>
            {!plan?.features.advance_request && (
              <Chip
                label="🔒 Paket Yükseltme Gerekli"
                size="small"
                sx={{
                  height: 22,
                  fontSize: '0.7rem',
                  bgcolor: alpha(theme.palette.warning.main, 0.2),
                  color: theme.palette.warning.main,
                  border: `1px solid ${alpha(theme.palette.warning.main, 0.3)}`,
                }}
              />
            )}
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={3}>
              {/* HEADERS */}
              <Grid item xs={12} md={6}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  Başlık
                </Typography>
                <TextField
                  id="headers"
                  name="headers"
                  fullWidth
                  multiline
                  rows={7}
                  placeholder='{"Content-Type": "application/json"}'
                  disabled={!plan?.features.advance_request}
                  value={values.headers}
                  onChange={handleChange}
                  error={!!errors.headers}
                  helperText={errors.headers || ' '}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CodeIcon sx={{ color: theme.palette.primary.main }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    opacity: !plan?.features.advance_request ? 0.6 : 1,
                    '& .MuiOutlinedInput-root': {
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                      fontFamily: 'monospace',
                    },
                  }}
                />
              </Grid>

              {/* BODY */}
              <Grid item xs={12} md={6}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  Gövde
                </Typography>
                <TextField
                  id="body"
                  name="body"
                  fullWidth
                  multiline
                  rows={7}
                  placeholder='{"key": "value"}'
                  disabled={!plan?.features.advance_request}
                  value={values.body}
                  onChange={(e) => setFieldValue('body', e.target.value)}
                  error={!!errors.body}
                  helperText={errors.body || ' '}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CodeIcon sx={{ color: theme.palette.primary.main }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    opacity: !plan?.features.advance_request ? 0.6 : 1,
                    '& .MuiOutlinedInput-root': {
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                      fontFamily: 'monospace',
                    },
                  }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}

      {/* KEYWORD SECTION */}
      {monitorType === 'keyword' && (
        <Card
          sx={{
            mb: 3,
            background: alpha(theme.palette.background.paper, 0.8),
            backdropFilter: 'blur(20px)',
            border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            borderRadius: 3,
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>
              Anahtar Kelime Ayarları
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  Anahtar Kelime
                </Typography>
                <TextField
                  id="keyWord"
                  name="keyWord"
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Aranacak kelime veya metin"
                  value={values.keyWord}
                  onChange={(e) => setFieldValue('keyWord', e.target.value)}
                  error={!!errors.keyWord}
                  helperText={errors.keyWord || ' '}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CodeIcon sx={{ color: theme.palette.primary.main }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  Anahtar Kelime Tipi
                </Typography>
                <TextField
                  id="keyWordType"
                  name="keyWordType"
                  fullWidth
                  select
                  value={values.keyWordType}
                  onChange={(e) => setFieldValue('keyWordType', e.target.value)}
                  error={!!errors.keyWordType}
                  helperText={errors.keyWordType || ' '}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                    },
                  }}
                >
                  <MenuItem value="txt">TXT</MenuItem>
                  <MenuItem value="html">HTML</MenuItem>
                  <MenuItem value="json">JSON</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}

      {/* TIMEOUT & STATUS CODES & PORT */}
      <Card
        sx={{
          mb: 3,
          background: alpha(theme.palette.background.paper, 0.8),
          backdropFilter: 'blur(20px)',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>
            İleri Ayarlar
          </Typography>

          <Grid container spacing={3}>
            {/* TIMEOUT */}
            {(monitorType === 'http' || monitorType === 'port' || monitorType === 'keyword') && (
              <Grid item xs={12} md={6}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  İstek Zaman Aşımı
                </Typography>
                <FormControl fullWidth>
                  <Select
                    id="timeOut"
                    name="timeOut"
                    value={values.timeOut}
                    onChange={(e) => setFieldValue('timeOut', e.target.value)}
                    sx={{
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                    }}
                  >
                    <MenuItem value={10}>10 saniye</MenuItem>
                    <MenuItem value={20}>20 saniye</MenuItem>
                    <MenuItem value={30}>30 saniye</MenuItem>
                    <MenuItem value={40}>40 saniye</MenuItem>
                    <MenuItem value={50}>50 saniye</MenuItem>
                    <MenuItem value={60}>60 saniye</MenuItem>
                  </Select>
                  <FormHelperText error={!!errors.timeOut}>
                    {errors.timeOut || ' '}
                  </FormHelperText>
                </FormControl>
              </Grid>
            )}

            {/* ALLOWED STATUS CODES */}
            {(monitorType === 'http' || monitorType === 'keyword') && (
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Typography sx={{ fontWeight: 600 }}>
                    İzin Verilen Durum Kodlar
                  </Typography>
                  {!plan?.features.status_code_alerts && (
                    <Chip
                      label="🔒"
                      size="small"
                      sx={{
                        height: 18,
                        fontSize: '0.65rem',
                        bgcolor: alpha(theme.palette.warning.main, 0.2),
                        color: theme.palette.warning.main,
                      }}
                    />
                  )}
                </Box>
                <TextField
                  id="allowedStatusCodes"
                  name="allowedStatusCodes"
                  placeholder="örnek: 200,400,500"
                  fullWidth
                  disabled={!plan?.features.status_code_alerts}
                  value={values.allowedStatusCodes}
                  onChange={handleChange}
                  error={!!errors.allowedStatusCodes}
                  helperText={errors.allowedStatusCodes || ' '}
                  sx={{
                    opacity: !plan?.features.status_code_alerts ? 0.6 : 1,
                    '& .MuiOutlinedInput-root': {
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>
            )}

            {/* PORT */}
            {monitorType === 'port' && (
              <Grid item xs={12} md={6}>
                <Typography gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                  Port
                </Typography>
                <TextField
                  id="port"
                  name="port"
                  placeholder="Port numarası 80,3000"
                  fullWidth
                  value={values.port}
                  onChange={handleChange}
                  error={!!errors.port}
                  helperText={errors.port || ' '}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>

      {/* SSL & DOMAIN MONITORING */}
      {(monitorType === 'http' || monitorType === 'keyword') && (
        <Accordion
          sx={{
            mb: 3,
            background: alpha(theme.palette.background.paper, 0.8),
            backdropFilter: 'blur(20px)',
            border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            borderRadius: '12px !important',
            '&:before': { display: 'none' },
            overflow: 'hidden',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              '& .MuiAccordionSummary-content': {
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              },
            }}
          >
            <Typography sx={{ fontWeight: 700 }}>
              SSL sertifikası ve Domain'ni kontrol et
            </Typography>
            {!plan?.features.ssl_monitoring && (
              <Chip
                label="🔒 Paket Yükseltme Gerekli"
                size="small"
                sx={{
                  height: 22,
                  fontSize: '0.7rem',
                  bgcolor: alpha(theme.palette.warning.main, 0.2),
                  color: theme.palette.warning.main,
                  border: `1px solid ${alpha(theme.palette.warning.main, 0.3)}`,
                }}
              />
            )}
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    background: alpha(theme.palette.background.default, 0.3),
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                  }}
                >
                  <Switch
                    disabled={!plan?.features.ssl_monitoring}
                    checked={values.sslCertControl}
                    onChange={() => setFieldValue('sslCertControl', !values.sslCertControl)}
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': {
                        color: theme.palette.primary.main,
                      },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.primary.main,
                      },
                      opacity: !plan?.features.ssl_monitoring ? 0.6 : 1,
                    }}
                  />
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    SSL Hatalarını Kontrol Et
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    background: alpha(theme.palette.background.default, 0.3),
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                  }}
                >
                  <Switch
                    disabled={!plan?.features.ssl_monitoring}
                    checked={values.sslCertExpire}
                    onChange={() => setFieldValue('sslCertExpire', !values.sslCertExpire)}
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': {
                        color: theme.palette.primary.main,
                      },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.primary.main,
                      },
                      opacity: !plan?.features.ssl_monitoring ? 0.6 : 1,
                    }}
                  />
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    SSL Son Tarihinde Hatırlat
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    background: alpha(theme.palette.background.default, 0.3),
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                  }}
                >
                  <Switch
                    disabled={!plan?.features.ssl_monitoring}
                    checked={values.domainExpire}
                    onChange={() => setFieldValue('domainExpire', !values.domainExpire)}
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': {
                        color: theme.palette.primary.main,
                      },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.primary.main,
                      },
                      opacity: !plan?.features.ssl_monitoring ? 0.6 : 1,
                    }}
                  />
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    Domain Son Tarihinde Hatırlat
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}

      {/* SLOW RESPONSE & FAIL COUNT */}
      {monitorType !== 'cronjob' && (
        <Card
          sx={{
            mb: 3,
            background: alpha(theme.palette.background.paper, 0.8),
            backdropFilter: 'blur(20px)',
            border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            borderRadius: 3,
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>
              Bildirim Ayarları
            </Typography>

            <Grid container spacing={3}>
              {/* SLOW RESPONSE ALERT */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    mb: 2,
                  }}
                >
                  <Typography sx={{ fontWeight: 600, flex: 1 }}>
                    Yavaş Yanıtda Bildirim Gönderilsin mi
                  </Typography>
                  <Switch
                    disabled={!plan?.features.slow_response_alerts}
                    checked={values.slowResponseAlertStatus}
                    onChange={() =>
                      setFieldValue('slowResponseAlertStatus', !values.slowResponseAlertStatus)
                    }
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': {
                        color: theme.palette.primary.main,
                      },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.primary.main,
                      },
                      opacity: !plan?.features.slow_response_alerts ? 0.6 : 1,
                    }}
                  />
                  {!plan?.features.slow_response_alerts && (
                    <Chip
                      label="🔒"
                      size="small"
                      sx={{
                        height: 18,
                        fontSize: '0.65rem',
                        bgcolor: alpha(theme.palette.warning.main, 0.2),
                        color: theme.palette.warning.main,
                      }}
                    />
                  )}
                </Box>

                <TextField
                  id="slowResponseAlertValue"
                  name="slowResponseAlertValue"
                  fullWidth
                  disabled={!values.slowResponseAlertStatus}
                  value={values.slowResponseAlertValue}
                  onChange={handleChange}
                  error={!!errors.slowResponseAlertValue}
                  helperText={errors.slowResponseAlertValue || ' '}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography variant="caption" sx={{ color: alpha('#fff', 0.5) }}>
                          milisaniye
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      background: alpha(theme.palette.background.default, 0.5),
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>

              {/* FAIL COUNT (for HTTP & KEYWORD) */}
              {(monitorType === 'http' || monitorType === 'keyword') && (
                <Grid item xs={12} md={6}>
                  <Typography gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
                    Kaç Hata Sonrası Bildirim Gönderilsin
                  </Typography>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton
                      onClick={handleDecrementForFailCount}
                      disabled={values.failCountRef <= 1}
                      sx={{
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                        borderRadius: '8px 0 0 8px',
                        background: alpha(theme.palette.background.default, 0.5),
                        '&:hover': {
                          background: alpha(theme.palette.primary.main, 0.1),
                        },
                      }}
                    >
                      <Remove />
                    </IconButton>

                    <TextField
                      id="failCountRef"
                      name="failCountRef"
                      value={values.failCountRef}
                      fullWidth
                      onChange={handleChange}
                      type="number"
                      inputProps={{
                        style: { textAlign: 'center' },
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          background: alpha(theme.palette.background.default, 0.5),
                          '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                            WebkitAppearance: 'none',
                            margin: 0,
                          },
                        },
                      }}
                    />

                    <IconButton
                      onClick={handleIncrementForFailCount}
                      sx={{
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                        borderRadius: '0 8px 8px 0',
                        background: alpha(theme.palette.background.default, 0.5),
                        '&:hover': {
                          background: alpha(theme.palette.primary.main, 0.1),
                        },
                      }}
                    >
                      <Add />
                    </IconButton>
                  </Stack>
                  <FormHelperText error={!!errors.failCountRef}>
                    {errors.failCountRef || ' '}
                  </FormHelperText>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      )}

      {/* ACTION BUTTONS */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
          mt: 4,
        }}
      >
        <Button
          variant="outlined"
          size="large"
          onClick={() => turnMonitorPage()}
          sx={{
            borderColor: alpha(theme.palette.primary.main, 0.5),
            color: theme.palette.primary.main,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            fontWeight: 600,
            '&:hover': {
              borderColor: theme.palette.primary.main,
              background: alpha(theme.palette.primary.main, 0.1),
            },
          }}
        >
          İptal
        </Button>

        <Button
          variant="contained"
          size="large"
          onClick={() => {
            if (isValid) {
              handleSubmit()
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Hata',
                text: 'Lütfen Formu Tekrar Gözden Geçirin',
                confirmButtonText: 'Tamam',
                background: theme.palette.background.paper,
                color: theme.palette.text.primary,
                confirmButtonColor: theme.palette.primary.main,
              })
              handleSubmit()
            }
          }}
          sx={{
            background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            fontWeight: 600,
            boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.3)}`,
            '&:hover': {
              background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
              transform: 'translateY(-2px)',
              boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.4)}`,
            },
          }}
        >
          {update.update ? 'Monitor Güncelle' : 'Monitor Oluştur'}
        </Button>
      </Box>
    </Box>
  )
}

export default ModernNewMonitorPage2